// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {DropMenuEl} from 'common/components/drop-menu';
import {PopoverCardEl} from 'common/components/popover-card';
import {PropertiesMenuEl} from 'common/query-builder/query-block/properties-menu/panel';

import type {ActionsPopover} from './index';
import {VIEWS} from './types';

export function template(this: ActionsPopover) {
  const {dropMenuOpen, view} = this.state;

  return (
    <div sel='.actions-popover-container'>
      <DropMenuEl
        attrs={{
          open: this.attr(`open`) && dropMenuOpen,
          'prevent-close-selectors': [`mp-create-entity-modal`, ...this.attr(`prevent-close-selectors`)],
          'experimental-positioning': true,
        }}
        on={{
          change: this.helpers.handleDropMenuChange,
          click: (ev) => ev.stopPropagation(),
        }}
        props={{
          positionParent: this.state.positionParent ?? this,
        }}
      >
        {view === VIEWS.BREAKDOWN ? (
          <PropertiesMenuEl
            disabledItems={this.helpers.breakdownDisabledItemsMap()}
            eventNames={[this.attr(`event`)]}
            open={this.attr(`open`)}
            projectId={this.helpers.getProjectId()}
            workspaceId={this.attr(`workspace-id`)}
            onSelect={this.helpers.handleBreakdownMenuSelect}
          />
        ) : (
          <PopoverCardEl
            attrs={{
              'button-options': this.attr(`button-options`),
              title: this.attr(`title`),
              subtitle: this.attr(`subtitle`),
              'is-segmented': this.attr(`is-segmented`),
            }}
            on={{
              action: this.helpers.handlePopoverAction,
              close: this.helpers.handlePopoverClose,
            }}
          >
            <slot />
            <slot attrs={{name: `footer`, slot: `footer`}} />
          </PopoverCardEl>
        )}
      </DropMenuEl>
    </div>
  );
}
